<div class="alert alert-danger" i18n>This listing is disabled. This means, that it cannot be found or booked by other users. <b>Existing bookings are not
  effected by this.</b></div>
